
import React from 'react';
import {
  cardContainer,
  card,
  coloredSquare,
  linesWrapper,
  greyLine,
  lineTwo,
} from './styles.homepageDesktop';

const boxColors = [
  'rgba(76, 201, 159, 1)',
  'rgba(253, 183, 61, 1)',
  'rgba(76, 179, 247, 1)',
];

const HomepageCenter = () => {
  return (
    <div style={cardContainer}>
      {boxColors.map((color, index) => (
        <div key={index} style={card}>
          <div style={{ ...coloredSquare, background: color }} />
          <div style={linesWrapper}>
            <div style={greyLine(true)} />
            <div style={greyLine(false)} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default HomepageCenter;
